import axios from 'axios'
/**
 * ----------------------------------- http request -----------------------------------
 */
const baseUrl = 'https://www.mingxin-star.com/zx';
// const baseUrl = 'http://localhost:8081';



const request = (url, formData, credentials, okStr, callBack, failBack, errorBack, jumpUrl, token, handle_unauth) => {
    axios.post(baseUrl + url, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'token': token
            }
        }, {
        withCredentials: credentials
    }).then(function data(data) {
        // 查看是否存在权限不足的问题
        if (typeof (data.data) === typeof (1)) {
            // -99为权限不足
            if (data.data === -99) {
                handle_unauth();
            }
            return;
        }
        if (data.data.code === 0) {
            callBack(data);
            if (okStr !== null) {
                (okStr, 1000, 1);
            }
            if (jumpUrl !== null && jumpUrl !== '') {
                setTimeout(function () {
                    jumpUrl()
                }, 1000);
            }
        } else {
            failBack(data);
        }
    }).catch(function error(error) {
        if (error.response !== undefined) {
            if (error.response.status === 401) {
                // show_alter('权限不足', 1000, 2);
                setTimeout(function () {
                    //处理
                }, 1000);
                return false;
            }
        }
        console.log(error.message);
        errorBack();
        // show_alter(error.message, null, 3);
    });
}

const download = (url, data, token, name, callback, handle_unauth, profix) => {
    axios.post(baseUrl + url, data,
        {
            headers: {
                'Content-Type': 'application/json',
                'token': token
            }, responseType: "blob"
        }, {
        withCredentials: true
    }).then(function data(data) {
        // 查看是否存在权限不足的问题
        if (typeof (data.data) === typeof (1)) {
            // -99为权限不足
            if (data.data === -99) {
                handle_unauth();
            }
            return;
        }
        // const filename = data.headers["content-disposition"];
        const blob = new Blob([data.data]);
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = decodeURIComponent(name.replace(/%/g, '%25') + profix);
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
        callback();
    }).catch(function error(error) {
        console.log(error);
    });
}

const fileDetail = (url, data, token, name, callback, handle_unauth) => {
    axios.post(baseUrl + url, data,
        {
            headers: {
                'Content-Type': 'application/json',
                'token': token
            }, responseType: "blob"
        }, {
        withCredentials: true
    }).then(function data(data) {
        // 查看是否存在权限不足的问题
        if (typeof (data.data) === typeof (1)) {
            // -99为权限不足
            if (data.data === -99) {
                handle_unauth();
            }
            return;
        }
        callback(data.data);
    }).catch(function error(error) {
        console.log(error);
    });
}

const formData_init = (arr) => {
    var formData = new FormData();
    arr.forEach(function (item) {
        formData.append(item.key, item.value);
    });
    return formData;
}

const formData_init_files = (formData, files) => {
    files.forEach(function (item) {
        formData.append('files', item);
    });
    return formData;
}

const reg_empty = /^\s*$/;
const w1 = '空字符提示';
const w2 = '字符长度错误';

const check_length = (value, max, min) => {
    return min < value.trim().length <= max;
}

const form_data_init = (form_data, res_data, p_name, p_value, empty, validation, max, min) => {
    var check_res = reg_empty.test(p_value);
    if (check_res && !empty) {
        //can not be empty
        res_data.push({ key: p_name, value: w1 });
        return false;
    }
    if (check_res && empty) {
        //can be empty
        if (max === -1) {
            form_data.push({ key: p_name, value: 0 });
        } else {
            form_data.push({ key: p_name, value: '' });
        }
        return true;
    }
    if (!check_res && empty) {
        if (max !== -1 && min !== -1) {
            check_res = check_length(p_value, max, min);
            if (!check_res) {
                res_data.push({ key: p_name, value: w2 });
                return false;
            } else {
                form_data.push({ key: p_name, value: p_value });
                return true;
            }
        }
    }
    //continue to do validation
    if (validation !== null) {
        check_res = validation.reg.test(p_value);
        if (!check_res) {
            res_data.push({ key: p_name, value: validation.wn });
            return false;
        }
    }
    if (max !== -1 && min !== -1) {
        check_res = check_length(p_value, max, min);
        if (!check_res) {
            res_data.push({ key: p_name, value: w2 });
            return false;
        }
    }
    form_data.push({ key: p_name, value: p_value });
}

// 获取token信息
const get_auth = () => {
    var res = null
    var token = localStorage.getItem("token")
    if (token !== undefined) {
        res = JSON.parse(token)
    }
    return res
}

const update_auth = () => {
    var res = get_auth()
    res.isFirstLogin = 1
    localStorage.setItem("token", JSON.stringify(res));
}

/**
 * ----------------------------------- http request END -----------------------------------
 */

/**
 * ----------------------------------- reg validation -----------------------------------
 */
const reg_date = () => {
    return {
        reg: /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1]))$/,
        wn: '日期格式错误'
    }
}

const reg_int = (len) => {
    if (len === -1) {
        return {
            reg: /^([1-9]\d?|0)$/,
            wn: '整数格式错误'
        };
    } else {
        return {
            reg: new RegExp("^([1-9]\\d{0," + len + "}|0)$"),
            wn: '限制长度整数格式错误'
        };
    }
}

const reg_double = (len) => {
    return {
        reg: new RegExp("^(([1-9]\\d*)|0)(\\.\\d{1," + len + "})?$"),
        wn: "金额格式错误"
    };
}
/**
 * ----------------------------------- reg validation END -----------------------------------
 */

const getDateStrYMD = () => {
    var date = new Date();
    var y = date.getFullYear();
    var MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + MM + '-' + d;
}

// float calculation -----------------------------------
const FloatMul = (arg1, arg2) => {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length;
    } catch(e) {
        console.log(e)
    }
    try {
        m += s2.split(".")[1].length;
    } catch(e) {
        console.log(e)
    }
    var result = Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10, m);
    return isNaN(result) ? 0 : result;
}

const FloatAdd = (arg1, arg2) => {
    var r1, r2, m;
    try {
        r1=arg1.toString().split(".")[1].length;
    } catch(e) {
        r1 = 0;
    }
    try {
        r2=arg2.toString().split(".")[1].length;
    } catch(e){
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (FloatMul(arg1, m) + FloatMul(arg2, m))/m;
}
// float calculation ----------------------------------- END

export default {
    request,
    form_data_init,
    formData_init,
    formData_init_files,
    reg_date,
    reg_int,
    reg_double,
    download,
    fileDetail,
    get_auth,
    update_auth,
    getDateStrYMD,
    FloatAdd,
    FloatMul
}